import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from "../../services/notification.service";

import { DataService } from '../../data.service';
import { UrlConstant } from '../../constants/url-constant';
import { AppData } from '../../constants/app-data';


@Component({
  selector: 'app-write-to-us',
  templateUrl: './write-to-us.component.html',
  styleUrls: ['./write-to-us.component.css']
})
export class WriteToUsComponent implements OnInit {
	message = "";
	
  wtu_form: FormGroup;
  public loginInvalid: boolean;
    private formSubmitAttempt: boolean;
  private returnUrl: string;
  
  constructor(private fb: FormBuilder, private formModule: ReactiveFormsModule, private route: ActivatedRoute,
//    private authService: AuthService,
	public notificationService: NotificationService,
    private router: Router,  
       public appData: AppData,   private dataService: DataService) { }


  ngOnInit(): void {
  	//this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/game';
    this.wtu_form = this.fb.group({
      wtu_name:  new FormControl('', [Validators.minLength(5), Validators.maxLength(50) ]),
      wtu_emailId: new FormControl('', [ Validators.minLength(6), Validators.maxLength(70), Validators.email]) ,
      wtu_comment: new FormControl('', [ Validators.minLength(6), Validators.maxLength(250)])
    });
//    if (await this.authService.checkAuthenticated()) {
//      await this.router.navigate([this.returnUrl]);
//    }
  }


  onSubmit() {
    if (this.wtu_form.valid) {
      try {
        const username = this.wtu_form.get('wtu_name').value;
        const emailId = this.wtu_form.get('wtu_emailId').value;
        const comment = this.wtu_form.get('wtu_comment').value;
//        await this.authService.login(username, password);
		this.writerToUs(username, emailId, comment);
      } catch (err) {
        this.appData.loginInvalid.next(true);
        console.log(err);
      }
    } else {
      
    }
  }
	
  public async writerToUs(username:string, emailId:string, comment:string){
  	var reqBody = {"name":username, "emailId":emailId, "desc":comment};
  	await this.dataService.sendPostRequestWithBody(UrlConstant.apiWriteToUs ,reqBody).toPromise().then((data: any)=>{
	      console.log(data);
	      this.message = data;
	      if("SUCCESS" === data.status){
	      	console.log("success code");
	      	//this.notificationService.success("Enterprise Created Successfully. " + this.message);
	      	this.notificationService.success(data.message);
	      
	      } else {
      		//this.router.navigate(['/dashboard', { 'userId': username }]);
      		this.notificationService.error(data.message);
	      }
	    });
  }
  

}
